import { useRef, useState } from 'react';

type Props = {
  imageUrl: string;
  onCrop: (blob: Blob) => void;
};

export default function ImageCropEditor({
  imageUrl,
  onCrop
}: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const [startX, setStartX] = useState(0);
  const [startY, setStartY] = useState(0);
  const [endX, setEndX] = useState(0);
  const [endY, setEndY] = useState(0);
  const [dragging, setDragging] = useState(false);

  const crop = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const w = Math.abs(endX - startX);
    const h = Math.abs(endY - startY);

    const cropCanvas =
      document.createElement('canvas');

    cropCanvas.width = w;
    cropCanvas.height = h;

    const cropCtx =
      cropCanvas.getContext('2d');

    if (!cropCtx) return;

    cropCtx.drawImage(
      canvas,
      Math.min(startX, endX),
      Math.min(startY, endY),
      w,
      h,
      0,
      0,
      w,
      h
    );

    cropCanvas.toBlob(blob => {
      if (blob) onCrop(blob);
    }, 'image/png');
  };

  return (
    <div>
      <canvas
        ref={canvasRef}
        width={900}
        height={600}
        onMouseDown={(e) => {
          setDragging(true);
          setStartX(e.nativeEvent.offsetX);
          setStartY(e.nativeEvent.offsetY);
        }}
        onMouseMove={(e) => {
          if (!dragging) return;
          setEndX(e.nativeEvent.offsetX);
          setEndY(e.nativeEvent.offsetY);
        }}
        onMouseUp={() => setDragging(false)}
        style={{
          border: '1px solid #ccc',
          maxWidth: '100%'
        }}
      />

      <br />

      <button onClick={crop}>
        Crop Selected Area
      </button>
    </div>
  );
}
